import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  formSubmissionSlug as getFormSubmissionSlug,
  setRelatedFormSubmissions,
} from "reduxSlices/formSubmissionSlice"
import * as API from "services/api"
import FormSubmissionResult from "components/shared/FormSubmissionResult"
import { errorToast } from "components/shared/toast"
import LoadingIndicator from "components/shared/LoadingIndicator"

const SearchResults = ({
  close,
  hasCompletedSearch,
  results,
  searchInProgress,
}) => {
  const formSubmissionSlug = useSelector(getFormSubmissionSlug)
  const dispatch = useDispatch()

  const createFormSubmissionRelationship = async (result) => {
    const response = await API.createFormSubmissionRelationship({
      formSubmissionSlug, relatedFormSubmissionId: result.id,
    })

    if (response.ok) {
      dispatch(setRelatedFormSubmissions(response.data))
      close()
    } else {
      errorToast(response.data.errors.join(", "))
    }
  }

  return (
    <>
      {
        searchInProgress && (
          <div className="pt-16">
            <LoadingIndicator textValue="Loading search results ..." />
          </div>
        )
      }
      {
        (hasCompletedSearch && !searchInProgress) && (
          <>
            {
              results.map((result) => (
                <FormSubmissionResult
                  key={result.id}
                  onClickResult={createFormSubmissionRelationship}
                  result={result}
                />
              ))
            }
          </>
        )
      }
    </>
  )
}

SearchResults.propTypes = {
  close: types.func.isRequired,
  searchInProgress: types.bool.isRequired,
  hasCompletedSearch: types.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  results: types.arrayOf(types.object).isRequired,
}

export default SearchResults
